var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recaptcha"},[_c('div',{staticClass:"recaptcha-container",attrs:{"id":_vm.container}})])}
var staticRenderFns = []

export { render, staticRenderFns }